module.exports = __webpack_public_path__ + "img/black-vip-bg-footer.476cbadf.png";